import styled from "styled-components";

export const DeviceTrackWrapper = styled.div`
    width: 100%;
    height: 75%;
    padding: 10px;
    box-sizing: border-box;
    clip-path: polygon(0 0, 100% 0, 100% 71%, 82% 88%, 66% 88%, 51.5% 100%, 0 100%, 0 0);
`;
